module.exports = __webpack_public_path__ + "static/abstract-cf3dffc2c32efc83100725317cb4e84c.jpg";